<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style>
#app{
    background: #F2F2F2;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue